import GameScene from "../scenes/GameScene";
import { GameObject } from "./GameObject";

export class Obstacle extends GameObject {
	constructor(scene: GameScene, x: number, y: number) {
		super(scene);
		const num = Phaser.Math.RND.between(1, 4);
		const img = this.addImage("obstacle" + num);
		// img.setScale(150 / img.width);
		this.x = x;
		this.y = y;

		scene.physics.world.enableBody(this, Phaser.Physics.Arcade.STATIC_BODY);
		const body = this.body as Phaser.Physics.Arcade.StaticBody;
		body.setSize(100, 100, false);
		const dx = -(body.position.x - this.x);
		const dy = -(body.position.y - this.y);
		body.setOffset(dx - img.displayWidth / 2, dy - img.displayHeight / 2);
	}
}
